/* Koalu landing page runtime – replaces the Replo/PageFly app scripts.
   Reads a per-page JSON config (#koalu-lp-config) produced by the converter. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('koalu-lp-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
  var actions = cfg.actions || {};
  var products = cfg.products || {};
  var state = {}; // productRid -> {idx, qty}
  var root = document.querySelector('.koalu-lp') || document;

  function rid(el) { return el && el.getAttribute && el.getAttribute('data-rid'); }
  function closestRid(el, map) {
    while (el && el !== document) {
      var r = rid(el);
      if (r && map[r]) return { el: el, rid: r };
      el = el.parentNode;
    }
    return null;
  }
  function prodState(r) {
    if (!state[r]) state[r] = { idx: products[r].defIdx || 0, qty: 1 };
    return state[r];
  }
  function currentVariant(r) {
    var p = products[r]; var s = prodState(r);
    return p.variants[s.idx] || p.variants[0];
  }
  function cartAdd(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function cartRemove(variantId) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(variantId), quantity: 0 }) });
  }
  function visible(n) { return !!(n && n.getClientRects().length && getComputedStyle(n).visibility !== 'hidden'); }
  var ALIAS = { buy: ['product'], review: ['reviews', 'reviews-section'], reviews: ['review', 'reviews-section'], product: ['buy'] };
  function findTarget(h) {
    var sel = function (x) { return Array.prototype.slice.call(document.querySelectorAll('[id="' + x + '"],[data-koalu-hash="' + x + '"],[data-koalu-hash-alias="' + x + '"]')); };
    var list = sel(h);
    (ALIAS[h] || []).forEach(function (a) { list = list.concat(sel(a)); });
    var pr = function (n) { return n.hasAttribute('data-koalu-hash-alias') ? 1 + parseInt(n.getAttribute('data-koalu-prio') || '0', 10) : 0; };
    list = list.map(function (n, i) { return [pr(n), i, n]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; });
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return list[0] || null;
  }
  function scrollToHash(hash, offset) {
    var t = findTarget(hash);
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - (offset || 0);
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function swapState(compRid, trigger) {
    var c = root.querySelector('[data-rid="' + compRid + '"]');
    if (!c) return;
    var kids = Array.prototype.filter.call(c.children, function (k) { return k.nodeType === 1; });
    var hidden = kids.filter(function (k) { return getComputedStyle(k).display === 'none'; });
    var shown = kids.filter(function (k) { return getComputedStyle(k).display !== 'none'; });
    var own = trigger && kids.filter(function (k) { return k.contains(trigger); })[0];
    if (own) {
      // "show more" pattern: reveal the hidden items and hide the button itself
      hidden.forEach(function (k) { k.style.setProperty('display', 'flex', 'important'); });
      own.style.setProperty('display', 'none', 'important');
      return;
    }
    if (hidden.length && shown.length) {
      hidden.forEach(function (k) { k.style.setProperty('display', 'flex', 'important'); });
      shown.forEach(function (k) { k.style.setProperty('display', 'none', 'important'); });
    }
  }
  function busy(el, on) { if (el) { el.style.opacity = on ? '0.6' : ''; el.style.pointerEvents = on ? 'none' : ''; } }

  function run(list, el) {
    var ctx = closestRid(el, products);
    var chain = Promise.resolve();
    list.forEach(function (a) {
      chain = chain.then(function () {
        switch (a.t) {
          case 'url': window.location.href = a.u; return;
          case 'ctxurl': if (ctx && products[ctx.rid].handle) window.location.href = '/products/' + products[ctx.rid].handle; return;
          case 'scroll': scrollToHash(a.h, a.o); return;
          case 'state': swapState(a.c, el); return;
          case 'qty':
            if (ctx) {
              var s = prodState(ctx.rid); s.qty = Math.max(1, s.qty + a.d);
              var q = ctx.el.querySelector('[data-koalu-qty]'); if (q) q.textContent = s.qty;
            }
            return;
          case 'atc':
            var p = a.handle ? { variants: a.variants || [], } : null;
            var variant = a.variant || (ctx ? currentVariant(ctx.rid) : null);
            if (!variant) { if (ctx && products[ctx.rid].handle) window.location.href = '/products/' + products[ctx.rid].handle; return; }
            var qty = a.q === 'ctx' ? (ctx ? prodState(ctx.rid).qty : 1) : (a.q || 1);
            busy(el, true);
            return cartAdd([{ id: variant, quantity: qty }]).then(function () {
              busy(el, false);
              if (ctx) prodState(ctx.rid).added = variant;
              if (a.cart) window.location.href = '/cart';
            }).catch(function () {
              busy(el, false);
              if (ctx && products[ctx.rid].handle) window.location.href = '/products/' + products[ctx.rid].handle;
            });
          case 'remove':
            if (ctx && prodState(ctx.rid).added) { var v = prodState(ctx.rid).added; prodState(ctx.rid).added = null; return cartRemove(v); }
            return;
        }
      });
    });
  }

  // generic click handler for elements with converted actions
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    // collapsibles / accordions (Replo + PageFly)
    var trig = t.closest && t.closest('[data-koalu-toggle]');
    if (trig) {
      var target = document.getElementById(trig.getAttribute('data-koalu-toggle'));
      if (target) {
        var open = target.hasAttribute('hidden') || target.style.display === 'none';
        if (open) { target.removeAttribute('hidden'); target.style.display = ''; } else { target.setAttribute('hidden', ''); }
        trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        var wrap = trig.closest('[data-state]'); if (wrap) wrap.setAttribute('data-state', open ? 'open' : 'closed');
        var icon = trig.querySelector('svg'); if (icon) icon.style.transform = open ? 'rotate(45deg)' : '';
      }
      ev.preventDefault(); return;
    }
    // variant / option pickers
    var opt = t.closest && t.closest('[data-koalu-option]');
    if (opt) {
      var list = opt.parentNode; var ctx = closestRid(opt, products);
      var opts = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-koalu-option]'));
      opts.forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); o.classList.toggle('koalu-selected', o === opt); });
      if (ctx) prodState(ctx.rid).idx = parseInt(opt.getAttribute('data-koalu-option'), 10) || 0;
      return;
    }
    // tabs
    var tab = t.closest && t.closest('[data-koalu-tab]');
    if (tab) {
      var tl = tab.closest('[role=tablist]');
      if (tl) Array.prototype.forEach.call(tl.querySelectorAll('[data-koalu-tab]'), function (b) {
        var on = b === tab; b.setAttribute('aria-selected', on); b.setAttribute('data-state', on ? 'active' : 'inactive');
        var p = document.getElementById(b.getAttribute('data-koalu-tab'));
        if (p) { if (on) { p.removeAttribute('hidden'); p.style.display = ''; p.setAttribute('data-state', 'active'); } else { p.setAttribute('hidden', ''); p.setAttribute('data-state', 'inactive'); } }
      });
      return;
    }
    // action buttons
    var el = t.closest && t.closest('[data-koalu-action]');
    if (el) {
      var list2 = actions[el.getAttribute('data-koalu-action')];
      if (list2 && list2.length) { ev.preventDefault(); run(list2, el); }
    }
  });
  root.addEventListener('keydown', function (ev) {
    if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.matches && ev.target.matches('[data-koalu-action],[data-koalu-toggle],[data-koalu-option],[data-koalu-tab]')) { ev.preventDefault(); ev.target.click(); }
  });

  // carousels (Replo carouselV3 + PageFly slideshows, converted to data-koalu-carousel)
  Array.prototype.forEach.call(root.querySelectorAll('[data-koalu-carousel]'), function (car) {
    var track = car.querySelector('[data-koalu-track]'); if (!track) return;
    var slides = Array.prototype.filter.call(track.children, function (s) { return s.nodeType === 1 && !s.hasAttribute('data-koalu-clone'); });
    if (slides.length < 2) return;
    var i = 0;
    var dots = car.querySelectorAll('[data-koalu-dot]');
    var auto = parseFloat(car.getAttribute('data-koalu-auto') || '0');
    var fade = car.getAttribute('data-koalu-fade') === '1';
    function go(n) {
      i = (n + slides.length) % slides.length;
      if (fade) { slides.forEach(function (s, k) { s.style.display = k === i ? '' : 'none'; }); }
      else { track.style.transition = 'transform 400ms ease'; track.style.transform = 'translate3d(' + (-slides[i].offsetLeft) + 'px,0,0)'; }
      Array.prototype.forEach.call(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); d.classList.toggle('koalu-dot-on', k === i); });
    }
    car.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-koalu-nav]');
      if (b && car.contains(b)) { ev.preventDefault(); ev.stopPropagation(); go(i + (b.getAttribute('data-koalu-nav') === 'next' ? 1 : -1)); return; }
      var d = ev.target.closest('[data-koalu-dot]');
      if (d && car.contains(d)) { ev.preventDefault(); go(parseInt(d.getAttribute('data-koalu-dot'), 10)); }
    });
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); sx = null; });
    if (fade) go(0);
    if (auto > 0) setInterval(function () { go(i + 1); }, auto * 1000);
    window.addEventListener('resize', function () { go(i); });
  });

  // countdown timers
  Array.prototype.forEach.call(root.querySelectorAll('[data-koalu-countdown]'), function (c) {
    var end = new Date(c.getAttribute('data-koalu-countdown')).getTime();
    var parts = c.querySelectorAll('[data-koalu-cd]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ms = Math.max(0, end - Date.now());
      var vals = { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
      if (parts.length === 3) vals.h += vals.d * 24;
      Array.prototype.forEach.call(parts, function (p) { p.textContent = pad(vals[p.getAttribute('data-koalu-cd')]); });
    }
    tick(); setInterval(tick, 1000);
  });

  // videos: make them playable
  Array.prototype.forEach.call(root.querySelectorAll('video'), function (v) { v.setAttribute('controls', ''); v.setAttribute('playsinline', ''); });
})();
